/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetRecruitmentCheckLimitQueryResponse, GetRecruitmentCheckLimit400 } from '../entities/GetRecruitmentCheckLimit'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetRecruitmentCheckLimitUrl() {
  return `/recruitment/check-limit` as const
}

/**
 * @description Проверка лимита заявок компании
 * @summary Проверка лимита заявок компании
 * {@link /recruitment/check-limit}
 */
export async function getRecruitmentCheckLimit(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetRecruitmentCheckLimitQueryResponse, ResponseErrorConfig<GetRecruitmentCheckLimit400>, unknown>({
    method: 'GET',
    url: getGetRecruitmentCheckLimitUrl().toString(),
    ...requestConfig,
  })
  return res.data
}